import * as types from "./actionsTypes";
import { agent } from "../utils/agent";
import { setToaster, showToaster } from "../utils/helpers";
import * as API from "../utils/apiPath";
import toggleNetworkRequestStatus from "./toggleNetworkRequestStatus"; 

export function leadGstDataSuccess(leadGstData) {
  return { type: types.LOAD_LEAD_GST_DATA_SUCCESS, leadGstData };
}
export function leadGstByLeadDataSuccess(leadGstByLeadData) {
  return { type: types.LOAD_LEAD_GST_BY_LEAD_INFO_SUCCESS, leadGstByLeadData };
}

const addEditLeadGst = (params) => {
    return async function (dispatch) {
      dispatch(toggleNetworkRequestStatus(true));
      try {
        const response = await agent.post(API.CREATE_LEAD_GST, params);
        dispatch(toggleNetworkRequestStatus(false));
        return response;
      } catch (error) {
        dispatch(toggleNetworkRequestStatus(false));
        throw error;
      } 
    };
}

const leadGstData = (params, preloader = true, returnVal = false) => {
    return async function (dispatch) {
      if (preloader) {
        dispatch(toggleNetworkRequestStatus(true));
      } 
      try {
        let response;
  
        if (returnVal) {
          response = await agent.post(API.GET_LEAD_GST, params);
        } else {
          response = await agent.post(API.GET_LEAD_GST, params);
        }
  
        if (preloader) {
          dispatch(toggleNetworkRequestStatus(false));
        }
  
        return response;
      } catch (error) {
        // Handle errors, e.g., log or dispatch an error action
        console.error("API Request Error:", error);
  
        if (preloader) {
          dispatch(toggleNetworkRequestStatus(false));
        } 
        throw error;
      }
    };
};

const leadGstByLeadData = (params, preloader = true, returnVal = false) => {
    return async function (dispatch) {
      if (preloader) {
        dispatch(toggleNetworkRequestStatus(true));
      } 
      try {
        let response;
  
        if (returnVal) {
          response = await agent.post(API.GET_LEAD_GST_BY_LEAD, params);
        } else {
          response = await agent.post(API.GET_LEAD_GST_BY_LEAD, params);
        }
  
        if (preloader) {
          dispatch(toggleNetworkRequestStatus(false));
        }
  
        return response;
      } catch (error) {
        // Handle errors, e.g., log or dispatch an error action
        console.error("API Request Error:", error);
  
        if (preloader) {
          dispatch(toggleNetworkRequestStatus(false));
        } 
        throw error;
      }
    };
};

export default {
    addEditLeadGst,
    leadGstData,
    leadGstDataSuccess,
    leadGstByLeadData,
    leadGstByLeadDataSuccess 
}